const kyivDateFormatter = new Intl.DateTimeFormat('en', {
  timeZone: 'Europe/Kyiv',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

const kyivDateParts = (instant: Date | string) => {
  const parts = kyivDateFormatter.formatToParts(
    typeof instant === 'string' ? new Date(instant) : instant,
  )
  const value = (type: Intl.DateTimeFormatPartTypes): string =>
    parts.find((part) => part.type === type)?.value ?? ''
  return { year: value('year'), month: value('month'), day: value('day') }
}

/**
 * The business calendar date as `YYYY-MM-DD`. `toISOString().slice(0, 10)` is the UTC date,
 * which lags the Kyiv date by a day between local midnight and 02:00 (03:00 in summer).
 */
export const kyivCalendarDate = (instant: Date | string = new Date()): string => {
  const { year, month, day } = kyivDateParts(instant)
  return `${year}-${month}-${day}`
}

export const kyivCalendarMonth = (instant: Date | string = new Date()): string => {
  const { year, month } = kyivDateParts(instant)
  return `${year}-${month}`
}
